import { useDocumentSignatureContext } from "@contexts";
import { ValidationRequiredModal } from "@components/documentCreation";

interface Props {
  onSecondaryAction?: () => void;
}

export function ValidationRequiredDocumentSignatureErrorModal({
  onSecondaryAction,
}: Props) {
  const { showValidationRequiredModal, setShowValidationRequiredModal } =
    useDocumentSignatureContext();

  const close = () => setShowValidationRequiredModal(false);

  return (
    <ValidationRequiredModal
      isOpen={showValidationRequiredModal}
      onClose={close}
      secondaryButtonText="Volver a inicio"
      onSecondaryAction={() => {
        close();
        onSecondaryAction?.();
      }}
    />
  );
}
